import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import clsx from "clsx";
import { DepartmentsTable } from "@components/tables";
import useModal from "@modals/modal-hook";
import { ColorfulButton } from "@components/common/common";
import { DownloadSVG, UploadSVG } from "@components/svgs";
import { $UserAddPermissions, ACTIONS, setModule } from "@store/user-store";
import { CompanyTabPropsT } from "@interfaces/company/company";
import { Modules } from "@interfaces/common";
import style from "@scss/pages/company/departments.module.scss";
import { fetchDepartments } from "@store/company/departments-store";
import { useSelectedCompanyQuery } from "@lib/company";
import { useDownloadDepartmentsTemplateUploadMutation } from "@lib/departments";
import { downloadBlob } from "@utils/downloadBlob";
import { useImportDepartments } from "@lib/departments/use-import-departments";

const Departments: React.FC<CompanyTabPropsT> = () => {
  const { company } = useSelectedCompanyQuery();
  const permissions = useUnit($UserAddPermissions);
  const { open } = useModal();
  const downloadFileMutation = useDownloadDepartmentsTemplateUploadMutation();
  const handleImportDepartments = useImportDepartments();

  useEffect(() => {
    setModule(Modules.SUBDIVISION);
  }, []);

  useEffect(() => {
    fetchDepartments();
  }, []);

  const handleDownloadTemplate = () => {
    if (!company) return;

    downloadFileMutation.mutate(
      {
        companyId: company.id,
      },
      {
        onSuccess: (blob) => {
          downloadBlob(blob, "Шаблон Подразделения должности.xlsx");
        },
      }
    );
  };

  return (
    <div className="tab-content-item">
      <div className={clsx(style.department_top_panel)}>
        {
          // permissions.roleIsIn([UserRoleEnum.Client], true) ? null :
          permissions.hasPermission(
            ACTIONS.companyStaffing_departments_allowedToCreate
          ) && (
            <>
              <ColorfulButton
                text={"Добавить подразделение"}
                onClick={() =>
                  open("CreateDepartmentModal", {
                    btnText: "Добавить",
                    modalData: {
                      modalTitle: "Добавить подразделение",
                      fieldTitle: "Название",
                    },
                  })
                }
              />
              <ColorfulButton
                text="Загрузить список подразделений"
                customIcon={<UploadSVG />}
                onClick={() => handleImportDepartments()}
              />
              <ColorfulButton
                text="Скачать шаблон для заполнения"
                customIcon={<DownloadSVG fill="#ffffff" />}
                onClick={() => handleDownloadTemplate()}
              />
            </>
          )
        }
      </div>
      <DepartmentsTable />
    </div>
  );
};

export default Departments;
